// Spring Security writes the CSRF token into a readable "XSRF-TOKEN" cookie (CookieCsrfTokenRepository).
// Fetch/AJAX requests echo it back as the X-XSRF-TOKEN header; a native form POST (e.g. the login
// form, which has to be a real form submission - see Login.js) has no way to set a custom header, so
// it falls back to the "_csrf" request parameter Spring Security also accepts.
function readCsrfToken() {
  const match = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : '';
}

export function getCsrfHeader() {
  const token = readCsrfToken();
  return token ? { 'X-XSRF-TOKEN': token } : {};
}

export function getCsrfToken() {
  return readCsrfToken();
}
